import { DeletePartnerNewsResponseSchema } from './delete-partner-news.schema';
export const deletePartnerNewsContract = {
    method: 'DELETE',
    path: '/api/v2/admin/partner-news/:id',
    description: 'Delete a partner news entry',
    responseSchema: DeletePartnerNewsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - superadmin only',
            404: 'Partner news not found'
        }
    }
};

//# sourceMappingURL=delete-partner-news.contract.js.map